import { useMemo } from 'react'
import { matchPath, useLocation } from 'react-router-dom'

import NavBar from '@/components/nav-bar'
import { useAuth } from '@/hooks/use-auth'
import { privateRoutesList } from '@/routes/config'

import { useStyles } from './styles'

interface ContainerProps {
  children: React.ReactNode
}

export function Container({ children }: ContainerProps) {
  const classes = useStyles()
  const location = useLocation()
  const { isAuthenticated, isLoading } = useAuth()

  const isPrivateRoute = useMemo(
    () =>
      !!privateRoutesList.find((route) =>
        matchPath(
          {
            path: route,
          },
          location.pathname,
        ),
      ),
    [location.pathname],
  )

  return (
    <>
      {isPrivateRoute && !isLoading && isAuthenticated && <NavBar />}

      <main className={classes.main}>{children}</main>
    </>
  )
}
